









import Vue from 'vue'
import Component from 'vue-class-component'
import {
  STATEMENTS_STORAGE_URL,
  TEMPLATE_VIEW_URL,
  STATEMENT_MESSAGE_TEMPLATE_VIEW_URL,
  STATEMENT_MESSAGE_TEMPLATE_PDF_VIEW_URL
} from '@/constants'
import Api from '@/api'

@Component({
  props: {
    src: String,
    name: String,
    type: {
      type: String,
      default: 'statement'
    },
    customStyles: {
      type: String
    }
  },
  watch: {
    url: {
      handler () {
        const component: any = this
        component.loadPdf()
      }
    }
  }
})
export default class PdfViewer extends Vue {
  blobUrl: string = ''
  error: boolean = false
  requestId: number = 0

  get url () {
    const src = this.$props.src
    const fileName = this.$props.name ? `${this.$props.name}` : ''
    switch (this.$props.type) {
      case 'statement':
        return `${STATEMENTS_STORAGE_URL}/${fileName}?file=${src}`
      case 'template':
        return `${TEMPLATE_VIEW_URL}/${src}${fileName}`
      case 'statement-message':
        return `${STATEMENT_MESSAGE_TEMPLATE_VIEW_URL}/${src}${fileName}`
      case 'pdf-template':
        return `${STATEMENT_MESSAGE_TEMPLATE_PDF_VIEW_URL}/${src}${fileName}`
      default:
        return ''
    }
  }

  created () {
    this.loadPdf()
  }

  beforeDestroy () {
    this.requestId++
    this.revokeBlobUrl()
  }

  async loadPdf () {
    const requestId = ++this.requestId
    this.revokeBlobUrl()
    this.error = false
    if (!this.url) {
      return
    }
    const blob = await Api.getInstance().doGetBlob(this.url, { t: Date.now() })
    if (requestId !== this.requestId) {
      return
    }
    if (!blob) {
      this.error = true
      return
    }
    this.blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))
  }

  revokeBlobUrl () {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = ''
    }
  }
}
